<template>
  <div class="login-container">
    <div class="enter-input">
      <div class="title">合续科技</div>
      <div class="description">PROVIDER CORE SYSTEM</div>
      <el-input
        v-model="user.account"
        placeholder="账户"
        class="user-enter-input"
        @focus="focusLogin"
        style="margin-top: 30px"
      ></el-input>
      <el-input
        v-model="user.password"
        type="password"
        placeholder="密码"
        class="user-enter-input"
        @focus="focusLogin"
      ></el-input>
      <el-button type="primary" @click="submit">登录</el-button>
    </div>
  </div>
</template>
<script>
// import userLogin from "./apis/login.js";
import { storage } from "./libs/src/utils/tools";
export default {
  data() {
    return {
      user: {
        account: "",
        password: "",
      },
    };
  },
 mounted(){
  console.log(this.$Auth.isLogined)
 },
  methods: {
    focusLogin() {
      document.addEventListener("keydown", (e) => {
        if ("Enter" == e.key) {
          this.submit();
        }
      });
    },
    submit() {
      console.log("submit");
      if (!this.user.account) {
        alert("请输入账户");
        return;
      }
      if (!this.user.password) {
        alert("请输入密码");
        return;
      }
      storage.remove("device");
      this.$Auth
        .submit(this.user.account, this.user.password)
        .then((res) => {
          if (!res.success) {
            alert(res.message);
            return;
          }
          // 使用location跳转防止重定向和用户手动返回
          let redirectURL = this.$Auth.redirectURL;
          console.log('重定向地址',redirectURL)
          if (redirectURL) {
            // 刷新并加载新数据
            window.location.href = "#" + redirectURL;
            this.$Application.openDecryptPage();
          } else {
            window.location.replace("#/");
          }
        })
        .catch((err) => {
          console.log(err);
          alert("账户密码错误");
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.login-container {
  // background-image: linear-gradient(to bottom right, #ccc, #fff,#999);
  display: flex;
  height: 100%;
  background: url('~@/assets/bg2.jpg') no-repeat center;
  background-size: cover;
  color: #fff;
  .enter-input {
    margin: auto;
    .title {
      font-size: 45px;
    }
    .description {
      font-size: 20px;
      margin: 15px auto;
    }
  }
  .user-enter-input {
    margin-bottom: 20px;
    input {
      background: rgba(255, 255, 255, 0.5);
    }
  }
}
</style>